import { render, staticRenderFns } from "./BrowseBuildingShobun.vue?vue&type=template&id=67043b3c&scoped=true&"
import script from "./BrowseBuildingShobun.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingShobun.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67043b3c",
  null
  
)

export default component.exports